import { render, staticRenderFns } from "./UserFigures.vue?vue&type=template&id=b10281f8"
import script from "./UserFigures.vue?vue&type=script&lang=js"
export * from "./UserFigures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports